// extracted by mini-css-extract-plugin
export default {"container":"set-language_container__O9EbO","flag":"set-language_flag__QScK7","active":"set-language_active__t6cHn"};